import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import isEmpty from "lodash/isEmpty";

/*---------------------------------------------------------------------------*/

function resetDataSaved() {
  return actions.resetDataSaved();
}

/*---------------------------------------------------------------------------*/

function attachListenersCitasDeVenta(idColegio = null) {
  return isEmpty(idColegio)
    ? null
    : dispatch => {
        dispatch(attachOnAddedCitasDeVenta(idColegio));
        dispatch(attachOnRemovedCitasDeVenta(idColegio));
        dispatch(attachOnChangedCitasDeVenta(idColegio));
      };
}

function attachOnAddedCitasDeVenta(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/citas_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_added",
        snap =>
          snap.hasChildren() && dispatch(actions.addedCitaDeVenta(snap.val()))
      );
}

function attachOnRemovedCitasDeVenta(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/citas_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_removed",
        snap =>
          snap.hasChildren() && dispatch(actions.removedCitaDeVenta(snap.val()))
      );
}

function attachOnChangedCitasDeVenta(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/citas_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_changed",
        snap =>
          snap.hasChildren() && dispatch(actions.changedCitaDeVenta(snap.val()))
      );
}

/*---------------------------------------------------------------------------*/

function detachListenersCitasDeVenta() {
  return dispatch => {
    rootRef.child("ventas/citas_de_venta").off("child_added");
    rootRef.child("ventas/citas_de_venta").off("child_removed");
    rootRef.child("ventas/citas_de_venta").off("child_changed");
  };
}

/*---------------------------------------------------------------------------*/

function limpiarCitasDeVenta() {
  return actions.limpiarCitasDeVenta();
}

/*---------------------------------------------------------------------------*/

function addNuevaCitaDeVenta(datos) {
  return dispatch => {
    const ruta = "ventas/citas_de_venta";
    const id = datos.isEdit ? datos.id : rootRef.child(ruta).push().key;
    const timestamp = datos.isEdit ? datos.timestamp : new Date().getTime();

    delete datos.isEdit;

    let insert = {};
    insert[`${ruta}/${id}`] = { ...datos, id, timestamp };
    rootRef.update(insert, () =>
      dispatch(
        actions.saveData({
          status: true,
          msg: "Cita Creada"
        })
      )
    );
  };
}

function borrarCitaDeVenta({ idCita }) {
  return dispatch => rootRef.child(`ventas/citas_de_venta/${idCita}`).remove();
}

function completarCitaDeVenta({ idCita }) {
  return dispatch => {
    let insert = {};
    insert[`ventas/citas_de_venta/${idCita}/completada`] = true;
    rootRef.update(insert);
  };
}
/*---------------------------------------------------------------------------*/

export {
  attachListenersCitasDeVenta,
  resetDataSaved,
  detachListenersCitasDeVenta,
  limpiarCitasDeVenta,
  addNuevaCitaDeVenta,
  borrarCitaDeVenta,
  completarCitaDeVenta
};



// WEBPACK FOOTER //
// ./src/ducks/ventasCitas/operations.js